import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const VersionDialog = ({ 
  open, 
  onClose, 
  caption,
  file, 
  isMajorChange,
  onMajorChange,
  onConfirm 
}) => {
  if (!caption) {
    return null;
  }
  const currentVersion = caption.version || 'v1.0';
  const versionMatch = currentVersion.match(/v(\d+)\.(\d+)/);

  let nextMajor = 'v2.0';
  let nextMinor = 'v1.1';

  if (versionMatch) {
    const majorNum = parseInt(versionMatch[1]);
    const minorNum = parseInt(versionMatch[2]);
    nextMajor = `v${majorNum + 1}.0`;
    nextMinor = `v${majorNum}.${minorNum + 1}`;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <CloudUploadIcon sx={{ mr: 1 }} />
        File Version Update
        <IconButton 
          size="small" 
          sx={{ ml: 1 }} 
          onClick={() => alert("Version changes help track the evolution of your caption files. Use major version changes (v1.0 → v2.0) for significant updates that change functionality. Use minor version changes (v1.0 → v1.1) for small fixes or improvements.")}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ minWidth: '300px' }}>
        <Box sx={{ mb: 3, mt: 1 }}>
          <Typography variant="body1" gutterBottom>
            Is this a major change or a minor change?
          </Typography>

          {file && (
            <Typography variant="body1" color="text.primary" fontWeight="500" sx={{ mt: 1 }}>
              New file: {file.name}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant={isMajorChange ? "contained" : "outlined"}
            color="info"
            onClick={() => onMajorChange(true)}
            fullWidth
          >
            Major Change ({currentVersion} → {nextMajor})
          </Button>

          <Button
            variant={!isMajorChange ? "contained" : "outlined"}
            color="info"
            onClick={() => onMajorChange(false)}
            fullWidth
          >
            Minor Change ({currentVersion} → {nextMinor})
          </Button>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionDialog;